import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { DeferBillingFeatureComponent } from './defer-billing-feature/defer-billing-feature.component';

export const DeferBillingRoute: Ng2StateDeclaration = {
    name: 'deferbilling',
    url: '/deferbilling',
    data: { requiresAuth: true },

    component: DeferBillingFeatureComponent
};
